'use client';

import { c as _c } from "react/compiler-runtime";
import { Divider } from '@algoacademy/design-system/web/layouts/Divider';
import { useQuery } from '@tanstack/react-query';
import { useParams, usePathname, useRouter } from 'next/navigation';
import { useState } from 'react';
import { useTRPC } from '@/app/_trpc/config';
import { useArticleStatesContext } from '@/app/baza/(collection)/_utils/ArticleStateContext/ArticleStateContext';
import { ArticleButton } from './ArticleButton';
import { ModuleButton } from './ModuleButton';
export function ModuleSidebar() {
  const $ = _c(9);
  const router = useRouter();
  const pathname = usePathname();
  const params = useParams();
  const collectionSlug = params.collectionSlug;
  const currentArticleSlug = params.articleSlug;
  const trpc = useTRPC();
  let t0;
  if ($[0] !== collectionSlug || $[1] !== trpc.docs.getCollectionStructure) {
    t0 = trpc.docs.getCollectionStructure.queryOptions({
      collectionSlug
    }, {
      staleTime: 600000
    });
    $[0] = collectionSlug;
    $[1] = trpc.docs.getCollectionStructure;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const {
    data
  } = useQuery(t0);
  const collection = data?.collection;
  const modules = data?.modules ?? [];
  const allArticles = modules.flatMap(_temp);
  let t1;
  if ($[3] !== currentArticleSlug) {
    t1 = a => a.slug === currentArticleSlug;
    $[3] = currentArticleSlug;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const currentGlobalIdx = allArticles.findIndex(t1);
  let t2;
  if ($[5] !== currentArticleSlug) {
    t2 = (m_0, i) => m_0.articles.some(a_0 => a_0.slug === currentArticleSlug) ? i : null;
    $[5] = currentArticleSlug;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const [openSections, setOpenSections] = useState(modules.map(t2).filter(_temp2));
  const {
    states: articleStates
  } = useArticleStatesContext();
  const pathSegments = pathname.split("/");
  const showSidebar = pathSegments.length === 4 && currentArticleSlug && data?.collection && data?.modules.some(m_1 => m_1.articles.some(a_1 => a_1.slug === currentArticleSlug));
  if (!showSidebar) {
    return null;
  }
  const t3 = "w-full space-y-2 pr-4 lg:w-[250px]";
  const t4 = modules.map((module, i_1) => {
    const isCurrentModule = module.articles.some(a_2 => a_2.slug === currentArticleSlug);
    return <div key={module.name} className="space-y-1"><ModuleButton name={module.name} isOpen={openSections.includes(i_1)} isCurrentModule={isCurrentModule} onClick={() => setOpenSections(prev => prev.includes(i_1) ? prev.filter(x => x !== i_1) : [...prev, i_1])} />{openSections.includes(i_1) && <ul className="flex flex-col px-2 pb-2">{module.articles.map(article => {
          const globalIdx = allArticles.findIndex(x_0 => x_0.slug === article.slug);
          return <ArticleButton key={article.id} article={article} canManageCollection={collection?.canManage ?? false} isCurrent={globalIdx === currentGlobalIdx} status={articleStates[article.id]} onClick={() => router.push(`/baza/${collectionSlug}/${article.slug}`)} />;
        })}</ul>}{i_1 < modules.length - 1 && <Divider />}</div>;
  });
  let t5;
  if ($[7] !== t4) {
    t5 = <main className={t3}>{t4}</main>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}
function _temp2(i_0) {
  return i_0 !== null;
}
function _temp(m) {
  return m.articles;
}